// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3uuvN","checkboxCol":"Table_checkboxCol__19vzX","emailCol":"Table_emailCol__3V5t-","actionCol":"Table_actionCol__8aRrZ"};